import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "morning",
  "midday",
  "evening",
  "endOfDay",
  "noReminders",
] as const

export default function ReminderPreference() {
  return (
    <MultiSelectPage
      translationKey="reminderPreference"
      options={OPTIONS}
      noneOptionKey="noReminders"
    />
  )
}
